import { Swiper } from "swiper/bundle";

const elementClass = "carousel-popup__thumbs-container";
const thumbsContainer = document.querySelector(`.${elementClass}`);

export const swiperThumbs = new Swiper(".js-swiper-thumbs", {
  slidesPerView: "auto",
  watchSlidesProgress: true,
  freeMode: true,
  loop: true,
  spaceBetween: 8,
  a11y: {
    firstSlideMessage: "Dit is de eerste slide",
    nextSlideMessage: "Naar de volgende slide",
    prevSlideMessage: "Naar de vorige slide",
    lastSlideMessage: "Dit is de laatste slide",
    paginationBulletMessage: "Ga naar slide {{index}}",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  on: {
    fromEdge: () => {
      thumbsContainer.classList.remove(`${elementClass}--at-beginning`);
      thumbsContainer.classList.remove(`${elementClass}--at-end`);
    },
    toEdge: (e) =>
      thumbsContainer.classList.add(
        e.isBeginning ? `${elementClass}--at-beginning` : `${elementClass}--at-end`,
      ),
  },
});
